module.exports = __webpack_public_path__ + "img/metamask-logo-png-transparent.4438fc27.png";